module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_5010.b85883ef.png";